import { ChainId, Currency } from '@pancakeswap/sdk'
import { BinanceIcon, TokenLogo } from '@pancakeswap/uikit'
import { useMemo } from 'react'
import { WrappedTokenInfo } from '@pancakeswap/token-lists'
import styled from 'styled-components'
import { ASSET_CDN } from 'config/constants/endpoints'
import { useHttpLocations } from '@pancakeswap/hooks'
import getTokenLogoURL from '../../utils/getTokenLogoURL'

const StyledLogo = styled(TokenLogo)<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: 50%;
`

export default function CurrencyLogo({
  currency,
  size = '24px',
  style,
}: {
  currency?: Currency
  size?: string
  style?: React.CSSProperties
}) {
  const uriLocations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)

  const srcs: string[] = useMemo(() => {
    if (currency?.isNative) return []

    if (currency?.isToken) {
      const tokenLogoURL = getTokenLogoURL(currency)
      // console.log({ tokenLogoURL })
      if (currency instanceof WrappedTokenInfo) {
        if (!tokenLogoURL) return [...uriLocations]
        return [...uriLocations, tokenLogoURL, `/images/chains/defaultToken.png`]
      }
      if (!tokenLogoURL) return [`/images/chains/defaultToken.png`]
      return [tokenLogoURL]
    }
    return [`/images/chains/defaultToken.png`]
  }, [currency, uriLocations])

  if (currency?.isNative) {
    if (currency.chainId === ChainId.BSC) {
      return <BinanceIcon width={size} style={style} />
    }
    // console.log({ aaa: `/images/chains/${currency.chainId}.png` })
    return (
      <StyledLogo
        size={size}
        srcs={[`/images/chains/${currency.chainId}.png`, `/images/chains/defaultToken.png`]}
        width={size}
        style={style}
      />
    )
  }
  // console.log({ bbb: `${currency?.symbol ?? 'token'} logo` })

  return <StyledLogo size={size} srcs={srcs} alt={`${currency?.symbol ?? 'token'} logo`} style={style} />
}
